import React = require("react")
import { GroupedOverviewEvent } from "../../../../backendApi/generated"
import { partition } from "../../../../utils/array"
import { hasValue } from "../../../../utils/asyncState"
import { Container } from "../../../Container"
import { nextMonth, nextWeek, pushEventAction, tomorrow } from "../../EventUtils"
import { EventOverviewLayoutProps } from "../EventOverviewState"
import { EventOverviewFilter } from "./EventOverviewFilter"
import { EventOverviewResultBlock } from "./EventOverviewResult"

export const EventOverview = (props: EventOverviewLayoutProps) => {
  const push = pushEventAction()

  document.title = "Activiteiten"
  if (!hasValue(props.events)) return <React.Fragment key="event-overview-loading" />

  const events = props.events.value
  const { Jumbo, jumboProps, filterUpdaters: { updateFrom, updatePage }, filterSettings: { from }, eventsOverviewClassNames } = props

  // Set up display for result count
  const results = events.TotalResults == 1 ? 'resultaat' : 'resultaten'
  let count = `${events.TotalResults} ${results}`

  // If the predicate holds for `from`, the partition is created,
  // otherwise all events are passed to the next partition.
  const partitionBy = (events: GroupedOverviewEvent[], predicate: (date: Date) => boolean) =>
    partition(events, (e) => predicate(e.Start))

  const [today, afterToday] = partitionBy(events.Result, d => d < tomorrow())
  const [isTomorrow, afterTomorrow] = partitionBy(afterToday, d => d < tomorrow(1))
  // Sometimes the start of next week is later than the start of next month, so we check both
  const [thisWeek, fromNextWeek] = partitionBy(afterTomorrow, d => d < nextWeek() && d < nextMonth())
  const [inNextWeek, pastNextWeek] = partitionBy(fromNextWeek, d => d < nextWeek(1) && d < nextMonth(1))
  const [thisMonth, pastThisMonth] = partitionBy(pastNextWeek, d => d < nextMonth())
  const [inNextMonth, later] = partitionBy(pastThisMonth, d => d < nextMonth(1))

  const afterNextMonth = nextMonth(1).toLocaleString('nl-NL', { month: 'long' })

  return <div className="general-page" key="event-overview-loaded">
    <Jumbo {...jumboProps} />

    <Container className="container--lg align--center">
      <section id="activities" className="activities">
        <div className="activities__container">
          <EventOverviewFilter {...props} />

          <div className="activities__content a-content" id="activity_results">

            <div className="a-filter__header">
              <h3 className="a-filter__title title--ms">{count}</h3>
            </div>

            <EventOverviewResultBlock label="Vandaag" events={today} />
            <EventOverviewResultBlock label="Morgen" events={isTomorrow} />
            <EventOverviewResultBlock label="Deze week" events={thisWeek} />
            <EventOverviewResultBlock label="Volgende week" events={inNextWeek} />
            <EventOverviewResultBlock label="Deze maand" events={thisMonth} />
            <EventOverviewResultBlock label="Volgende maand" events={inNextMonth} />
            <EventOverviewResultBlock label={`In ${afterNextMonth} en later`} events={later} />

            <ul className="a-pager">
              <li className="prev" >
                <button
                  className={eventsOverviewClassNames.timelineButton}
                  onClick={() => {
                    push('vanaf', 'eerder')
                    updatePage(events.PreviousPage.page)
                    // updateFrom(events.PreviousPage.from)
                  }}
                  disabled={!events.PreviousPage}>
                  Eerder
                </button>
              </li>
              <li className="next" >
                <button
                  className={eventsOverviewClassNames.timelineButton}
                  onClick={() => {
                    push('vanaf', 'later')
                    updatePage(events.NextPage.page)
                    // updateFrom(events.NextPage.from)
                  }}
                  disabled={!events.NextPage}>
                  Later
                </button>
              </li>
            </ul>

          </div>
        </div>
      </section>
    </Container>
  </div>
}
